var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpgrade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1l3.707 7.513L25 9.72l-6 5.847 1.413 8.26-7.413-3.9-7.42 3.9L7 15.567 1 9.72l8.293-1.207L13 1zM13 16.847V10.12",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.28 12.5L13 9.78l2.713 2.72",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjYgMjUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMyAxTDE2LjcwNjcgOC41MTMzM0wyNSA5LjcyTDE5IDE1LjU2NjdMMjAuNDEzMyAyMy44MjY3TDEzIDE5LjkyNjdMNS41OCAyMy44MjY3TDcgMTUuNTY2N0wxIDkuNzJMOS4yOTMzMyA4LjUxMzMzTDEzIDFaIiBzdHJva2U9ImN1cnJlbnQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEzIDE2Ljg0NjdWMTAuMTIwMSIgc3Ryb2tlPSJjdXJyZW50IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMC4yOCAxMi41TDEzIDkuNzgwMDNMMTUuNzEzNCAxMi41IiBzdHJva2U9ImN1cnJlbnQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgUpgrade as ReactComponent };